import React from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { getTurkishSuffixForNumbers } from "../../utils/getTurkishSuffixForNumbers";
import useWidth from "../../hooks/useWidth";

export default function ShowcaseReviews({ showcaseReviews, product }) {
  const width = useWidth();

  const settings = {
    dots: true, // This will show dot indicators at the bottom
    infinite: true,
    speed: 500,
    slidesToShow: width < 600 ? 1 : 2,
    slidesToScroll: 1,
    swipeToSlide: true,
  };

  const styleSlider = {
    maxWidth: "100%",
    overflow: "hidden",
    // boxShadow: "rgba(0, 0, 0, 0.35) 0px 5px 15px",
    margin: "0 0 1rem 0",
  };
  const starStyle = { color: "#f0c040" };

  function calculateRatingOutOfHundred(rate) {
    return Math.floor((rate / 5) * 100);
  }

  return (
    <>
      <h1 className="padupside1 txtcenter fs125 w90p bold-font">
        Her 100 Kullanıcıdan {calculateRatingOutOfHundred(product?.rating)}
        {getTurkishSuffixForNumbers(
          calculateRatingOutOfHundred(product?.rating)
        )}{" "}
        Memnun
      </h1>
      <h2 className="txtcenter fs1 padupsideq w90p">
        Memnun olmayanlar kolayca para iadesi alıyor
      </h2>
      <p className="padupsideq marupsideq fs1">
        Daha çok yorum için <span className="beddo-border-bottom">KAYDIR</span>
      </p>
      <div style={styleSlider}>
        {showcaseReviews?.length > 0 && (
          <Slider {...settings}>
            {showcaseReviews.map((review, index) => (
              <div key={index} className="row-left">
                <div className="mar1 fs125 shadow-all rad5r">
                  <p className="padh">
                    {[...Array(5).keys()].map((num) => (
                      <i key={num} className="fa fa-star" style={starStyle}></i>
                    ))}
                  </p>
                  <p className="pad1 w90p">{review.comment}</p>
                  <p className="padh w90p">
                    {review.firstName} {review.lastName}
                  </p>
                </div>
                <div className="white">c</div>
              </div>
            ))}
          </Slider>
        )}
      </div>
    </>
  );
}
